module.exports = __webpack_public_path__ + "static/media/Ny-introduksjon-til-Ordforstaels.a3bce167.mp3";